import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";
const searchTypeMap = new Map();

export default function ATTPMemberSearchForm(props) {
  const NAME = "NAME";
  const PHONE_NUMBER = "PHONE_NUMBER";
  const EMAIL = "EMAIL";

  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || props.currState.LastName || "");
  const [postalCode, setPostalCode] = useState(
    props.currState.MemberLookup.postalCode || props.currState.postalCode || "",
  );
  const [phoneNumber, setPhoneNumber] = useState(
    props.currState.MemberLookup.phoneNumber || props.currState?.Number?.replace(/\D/g, "") || "",
  );
  const [email, setEmail] = useState(props.currState.MemberLookup.email || props.currState.email || "");
  const [lessThan7, setLessThan7] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: PHONE_NUMBER, value: t("description.ConfirmCustomerPhoneNumber") },
    { key: EMAIL, value: t("description.ConfirmCustomerEmail") },
    { key: NAME, value: t("description.Name") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(
    props.currState.MemberLookup?.searchType === "AUTO_SEARCH"
      ? PHONE_NUMBER
      : props.currState.MemberLookup?.searchType || PHONE_NUMBER,
  );

  useEffect(() => {
    setFirstName(firstName);
    setLastName(lastName);
    setPhoneNumber(phoneNumber);
    setPostalCode(postalCode);
    setEmail(email);
  }, [selectedSearchType]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        postalCode: postalCode,
        email: email,
        searchType: selectedSearchType,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();

    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        postalCode: postalCode,
        email: email,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const memberNumberLimit = (e) => {
    if (e.target.value.length > 7) {
      e.target.value = e.target.value.slice(0, -1);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => setSelectedSearchType(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*FIRST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="string"
                  placeholder={t("description.ConfirmCustomerFirstName")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LAST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="string"
                  placeholder={t("description.ConfirmCustomerLastName")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*POSTAL CODE*/}
          {selectedSearchType === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerPostalCode")}:</div>
                <input
                  type="number"
                  placeholder={t("description.ConfirmCustomerPostalCode")}
                  name="postalCode"
                  className="input form-control required"
                  value={postalCode}
                  onChange={(e) => {
                    setPostalCode(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*PHONE_NUMBER*/}
          {selectedSearchType === PHONE_NUMBER && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  placeholder={t("description.ConfirmCustomerPhoneNumber")}
                  name="phoneNumber"
                  className="input form-control required"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*EMAIL*/}
          {selectedSearchType === EMAIL && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerEmail")}:</div>
                <input
                  type="string"
                  placeholder="example@gmail.com"
                  name="email"
                  className="input form-control required"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
